import React from "react";
import {
  AssetListContainer,
  AssetListItem,
  OtherCryptoAssetsContainer
} from "./style";
import Image from "next/image";
import NextLink from "components/parts/NextLink";
import { getIcon } from "utils/currencies/icon";
import { useTranslations } from "i18n";
import { Colors } from "themes/color-palette";
import {
  FontWeight,
  HubbleBody,
  HubbleDisplay
} from "components/parts/Typography";
import type { AllPricesResponse } from "utils/prices";

interface OtherCryptoAssetsComponentProps {
  otherCoinsToBuy: AllPricesResponse;
}

const OtherCryptoAssets = (props: OtherCryptoAssetsComponentProps) => {
  const { otherCoinsToBuy } = props;
  const t = useTranslations("how-to-buy");

  return (
    <OtherCryptoAssetsContainer>
      <HubbleDisplay bold size="lg" as={"h2"} color={Colors.white} mb={4}>
        {t("otherCryptoAssetsTitle")}
      </HubbleDisplay>
      <AssetListContainer justify="center" wrap={true}>
        {otherCoinsToBuy.map(({ name, slug, coin }) => (
          <NextLink
            newTab
            href={`https://www.gemini.com/how-to-buy/${slug}`}
            key={name}
          >
            <AssetListItem align="center">
              <Image
                src={getIcon(coin)}
                height={40}
                width={40}
                alt={t("coinImage", { coinName: name })}
              />
              <HubbleBody
                fontWeight={parseInt(FontWeight.semiBold)}
                size="lg"
                color={Colors.white}
              >
                {t("guideToBuying")} {name}
              </HubbleBody>
            </AssetListItem>
          </NextLink>
        ))}
      </AssetListContainer>
    </OtherCryptoAssetsContainer>
  );
};
export default OtherCryptoAssets;
